import { LitElement, html, css } from 'lit';
import { property, query, customElement } from 'lit/decorators.js';

import { showNotification, confirmPopup } from '../../LanghoutBetonPortal';
import {
  authenticatedAPICall,
  isSuccessfulAPIResponse,
} from '../../client/api-client';
import '../../elements/langhout-button/langhout-button';
import '../../elements/search-dropdown/search-dropdown';
import { SearchDropdown } from '../../elements/search-dropdown/search-dropdown';
import '../../elements/langhout-button/langhout-button';
import '../../elements/langhout-checkbox/langhout-checkbox';
import { LanghoutCheckbox } from '../../elements/langhout-checkbox/langhout-checkbox';
import {
  formatDateInput,
  PickupOrderStatusInitState,
  PickupOrderStatusOnCall,
  PickupOrderStatusReadyToBeProcessed,
  ProductStockTypeOnRequest,
  setBodyStyleObject,
  StockStatusInStock,
  StockStatusLimited,
  StockStatusOutOfStock,
} from '../../util/util';
import { repeat } from 'lit/directives/repeat.js';
import {
  PickupOrderProductCreateRequest,
  PickupOrderCreateReqeust,
  Product,
  ProdEdit,
  ProductExact,
  ProductStockView,
  DeliveryOverTime,
  StyleObject,
  ProductPlanningValidationRequest,
} from '../../types/types';
import { minusIcon, plusIcon, uploadIcon } from '../../elements/icons/icons';
import { sharedStyles } from '../../elements/shared-styles';

type CustomerCodeByNameResponse = {
  customer_code: string;
  error_message: string;
};

@customElement('langhout-beton-create-pickup-order')
export class CreatePickupOrder extends LitElement {
  private readonly styleObject: StyleObject = {
    '--wrapper-width': '1000px',
    '--row-width': '600px',
    '--label-width': '350px',
    '--margin-bottom': '25px',
    '--svg-width': '30px',
    '--amount-column-width': '100px',
    '--amount-margin-right': '20px',
    '--amount-unit-column-width': '140px',
  };

  static styles = [
    sharedStyles,
    css`
      .outer-wrapper {
        padding-bottom: 200px;
      }

      .row {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
        flex-flow: row wrap;
      }

      .create-wrapper {
        padding-bottom: 40px;
        width: 100%;
        background-color: var(--primary-color);
        color: var(--text-color-light);
        border-radius: 10px;
        max-width: var(--wrapper-width);
      }

      .pdf-viewer {
        width: 100%;
        margin-left: 20px;
        margin-right: 20px;
        max-width: var(--wrapper-width);
        min-height: 980px;
      }

      .label {
        text-align: left;
        width: var(--label-width);
        font-weight: bold;
        margin-bottom: var(--margin-bottom);
      }

      .input-column {
        margin-bottom: var(--margin-bottom);
        width: calc(var(--row-width) - var(--label-width));
      }

      .input-column-prod-amount {
        text-align: left;
        width: calc(var(--amount-column-width) - var(--amount-margin-right));
        max-width: calc(
          var(--amount-column-width) - var(--amount-margin-right)
        );
        margin-right: var(--amount-margin-right);
      }

      .label-column-prod-amount {
        width: var(--amount-column-width);
        text-align: left;
        margin-bottom: var(--margin-bottom);
      }

      .label-column-amount-unit {
        width: var(--amount-unit-column-width);
        text-align: left;
      }

      .label-column-amount-type {
        width: calc(
          var(--row-width) - var(--amount-column-width) - var(
              --amount-unit-column-width
            )
        );
        text-align: left;
      }

      .input-column-prod {
        margin-bottom: var(--margin-bottom);
        width: calc(
          var(--row-width) - var(--amount-column-width) - var(
              --amount-unit-column-width
            )
        );
        max-width: calc(
          var(--row-width) - var(--amount-column-width) - var(
              --amount-unit-column-width
            )
        );
      }

      .checkbox-wrapper {
        margin-bottom: var(--margin-bottom);
      }

      .amount-unit {
        width: var(--amount-unit-column-width);
      }

      .fill-block-products {
        width: calc(var(--row-width) - var(--label-width) - var(--svg-width));
      }

      .fill-block-checkbox {
        width: 205px;
      }

      .checkbox-label {
        text-align: left;
        width: var(--label-width);
      }

      @media (max-width: 779px) {
        .input-column {
          margin-bottom: var(--margin-bottom);
          width: 250px;
          max-width: 250px;
        }

        search-dropdown {
          width: 250px !important;
        }

        .fill-block,
        .fill-block-checkbox,
        .fill-block-products {
          width: 0px;
        }

        .product-label {
          width: 220px;
        }

        .remove-prod {
          right: 0;
        }
      }

      @media (max-width: 925px) {
        .remove-prod {
          right: 0px !important;
        }
        .dot {
          right: 35px !important;
        }
      }

      search-dropdown {
        width: 190px;
      }

      langhout-button {
        width: 150px;
        margin-right: 30px;
      }

      .prod-row {
        position: relative;
      }

      .remove-prod {
        position: absolute;
        top: 2px;
        right: 50px;
      }

      langhout-checkbox {
        margin-left: 15px;
      }

      :host([disableButtons]) {
        pointer-events: none;
        opacity: 0.7;
      }

      .dot {
        position: absolute;
        right: 100px;
        border: 1px solid white;
        background-color: white;
        height: 25px;
        width: 25px;
        min-width: 25px;
        border-radius: 50%;
        display: inline-block;
        margin-right: 10px;
        margin-left: 10px;
        margin-top: 5.5px;
      }

      .dot-red {
        background-color: red;
      }

      .dot-orange {
        background-color: orange;
      }

      .dot-green {
        background-color: var(--primary-color);
      }

      .weight-display {
        width: calc(var(--row-width) - var(--label-width));
        text-align: right;
      }

      input[type='file'] {
        display: none;
      }

      .drop-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.9);
        color: white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        transition:
          opacity 0.3s ease,
          visibility 0.3s ease;
      }

      .dragover {
        opacity: 0.5;
      }

      textarea {
        padding: 10px;
        width: calc(100% - 22px);
        height: 100px;
      }
    `,
  ];

  @query('#orderID')
  public orderID?: HTMLInputElement;

  @query('#shippingID')
  public shippingID?: HTMLInputElement;

  @query('#externalID')
  public externalID?: HTMLInputElement;

  @query('#pickupDate')
  public pickupDate?: HTMLInputElement;

  @query('#shippingCity')
  public shippingCity?: HTMLInputElement;

  @query('#customerName')
  public customerName?: HTMLInputElement;

  @query('#comment')
  public comment?: HTMLInputElement;

  @query('#packageReceiptNote')
  public packageReceiptNote?: HTMLInputElement;

  @query('#pdfNote')
  public pdfNote?: HTMLTextAreaElement;

  @query('#initEarlyCheckbox')
  public initEarlyCheckbox?: LanghoutCheckbox;

  @query('#onCallCheckbox')
  public onCallCheckbox?: LanghoutCheckbox;

  private customer_code = '';

  @property({ type: Boolean, reflect: true })
  private disableButtons = false;

  @property({ type: String, attribute: true, reflect: true })
  private salesOrderNumber = '';

  constructor() {
    super();
    setBodyStyleObject(this.styleObject);
    document.addEventListener(
      'confirm_pickup_order_create',
      this.executePickupOrderCallWithoutValidation as EventListener,
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(
      'confirm_pickup_order_create',
      this.executePickupOrderCallWithoutValidation as EventListener,
    );
  }

  @property({ type: Array, attribute: true })
  public prods: ProdEdit[] = [
    {
      amount: 0.0,
      index: 0,
      stock_status: StockStatusInStock,
    },
  ];

  public prodIndex = 0;

  @property({ type: Number, attribute: true })
  private totalWeight = 0;

  @property({ type: String, attribute: true, reflect: true })
  private productCodeFilter = '';

  private exactProducts: ProductExact[] = [];

  private dragCounter = 0;

  @property({ type: Boolean, attribute: true, reflect: true })
  private isDragging = false;

  @property({ type: Boolean, attribute: true, reflect: true })
  private isProcessing = false;

  @property({ type: String, attribute: true, reflect: true })
  private pdfFileB64 = '';

  render() {
    let classes = 'row outer-wrapper';
    if (this.isDragging) {
      classes += ' dragover';
    }
    return html`
      <input
        type="file"
        id="fileInput"
        @change=${this._handleFileInputChange}
      />
      <div
        class="${classes}"
        @dragenter=${this._handleDragEnter}
        @dragover=${this._preventDefaults}
        @dragleave=${this._handleDragLeave}
        @drop=${this._handleDrop}
      >
        ${this.renderDropOverlay()}
        <div class="create-wrapper column">
          <h3>Pickup order invoeren</h3>
          ${this.renderNormalInputs()}
          <div class="row">
            <div class="label product-label">Producten</div>
            <div class="fill-block-products"></div>
            <div class="plus-icon" @click="${this.addProdInput}">
              ${plusIcon()}
            </div>
          </div>
          <div class="row">
            <div class="label-column-prod-amount">Aantal</div>
            <div class="label-column-amount-unit">Verk. Eenh.</div>
            <div class="label-column-amount-type">Type</div>
          </div>
          ${repeat(
            this.prods,
            prod => prod.index,
            (item, index) => {
              return html`
                <div class="row prod-row">
                  <div class="input-column-prod-amount">
                    <input
                      value="${item.amount ? item.amount : ''}"
                      placeholder="aantal"
                      type="number"
                      min="1"
                      step="1"
                      class="product-amount"
                      name="product amount"
                      @input=${() => {
                        this.checkStockStatus();
                        this.calculateTotalWeight();
                      }}
                    />
                  </div>
                  ${this.renderAmountInUnits(index)}
                  <div class="fill-block"></div>
                  <div class="input-column-prod">
                    <search-dropdown
                      .productCodeFilter="${this.productCodeFilter}"
                      .salesOrderNumber="${this.salesOrderNumber}"
                      .selected="${item.prod}"
                      class="search-dropdown"
                      @change="${() => {
                        this.checkStockStatus();
                        this.calculateTotalWeight();
                      }}"
                    ></search-dropdown>
                  </div>
                  ${this.renderStockStatus(item.stock_status)}
                  <div
                    class="remove-prod"
                    @click="${() => {
                      this.removeProdInput(index);
                      setTimeout(() => {
                        this.checkStockStatus();
                        this.calculateTotalWeight();
                      }, 10);
                    }}"
                  >
                    ${minusIcon()}
                  </div>
                </div>
              `;
            },
          )}
          <div class="row">
            <div class="label product-label">Totaal gewicht</div>
            <div class="weight-display">
              ${this.totalWeight.toLocaleString('nl-NL')} kg
            </div>
          </div>
          <div class="row checkbox-wrapper">
            <div class="checkbox-label">Direct klaarzetten</div>
            <langhout-checkbox
              reverse
              id="initEarlyCheckbox"
            ></langhout-checkbox>
            <div class="fill-block-checkbox"></div>
          </div>
          <div class="row checkbox-wrapper">
            <div class="checkbox-label">Op afroep</div>
            <langhout-checkbox reverse id="onCallCheckbox"></langhout-checkbox>
            <div class="fill-block-checkbox"></div>
          </div>
          <div class="row">
            <div class="fill"></div>
            <langhout-button
              reverse
              text="Afronden"
              @click="${this.createPickupOrder}"
            ></langhout-button>
          </div>
        </div>
        ${this.renderPDF()}
      </div>
    `;
  }

  renderPDF = () => {
    if (this.pdfFileB64 === '') {
      return html``;
    }

    return html` <iframe
      class="pdf-viewer"
      src="data:application/pdf;base64,${this.pdfFileB64}#navpanes=0"
    ></iframe>`;
  };

  renderDropOverlay = () => {
    if (this.isDragging) {
      if (this.isProcessing) {
        return html`<div class="drop-overlay">
          <p>Processing PDF, please wait...</p>
        </div>`;
      }
      return html`<div class="drop-overlay">
        <p>Drop pdf to upload ${uploadIcon()}</p>
      </div>`;
    }
    return html``;
  };

  renderAmountInUnits = (index: number) => {
    if (!this.shadowRoot) {
      return html`<div class="amount-unit">-</div>`;
    }

    const productSelects = this.shadowRoot.querySelectorAll('.search-dropdown');
    const prodAmountInputs =
      this.shadowRoot.querySelectorAll('.product-amount');
    const searchDropDown = <SearchDropdown>productSelects[index];
    const amountInputElement = <HTMLInputElement>prodAmountInputs[index];

    if (
      !searchDropDown ||
      !searchDropDown.selected ||
      !amountInputElement ||
      !amountInputElement.value
    ) {
      return html`<div class="amount-unit">-</div>`;
    }
    const amountValue = parseFloat(amountInputElement.value);
    const selected = searchDropDown.selected;
    return html`<div class="amount-unit">
      ${Math.round((amountValue / selected.pieces_per_unit) * 1000) / 1000}
      ${selected.unit}
    </div>`;
  };

  renderStockStatus = (stockStatus: number) => {
    if (stockStatus === StockStatusInStock) {
      return html`<div class="dot dot-green"></div>`;
    }
    if (stockStatus === StockStatusOutOfStock) {
      return html`<div class="dot dot-red"></div>`;
    }
    if (stockStatus === StockStatusLimited) {
      return html`<div class="dot dot-orange"></div>`;
    }
    return html`<div class="dot dot-green"></div>`;
  };

  checkStockStatus = async () => {
    if (!this.shadowRoot) {
      return;
    }

    const productSelects = this.shadowRoot.querySelectorAll('.search-dropdown');
    const prodAmountInputs =
      this.shadowRoot.querySelectorAll('.product-amount');
    productSelects.forEach((e: Element, index: number) => {
      if (!this.pickupDate) {
        return;
      }
      const searchDropDown = <SearchDropdown>productSelects[index];
      const amountInputElement = <HTMLInputElement>prodAmountInputs[index];

      const amountValue = parseFloat(amountInputElement.value);
      const selected = searchDropDown.selected;

      if (
        !selected ||
        selected.id === undefined ||
        selected.id === '00000000-0000-0000-0000-000000000000'
      ) {
        return;
      }

      const pickupDate = new Date(this.pickupDate.value);
      if (selected && amountValue > 0) {
        this.checkStockStatusForIndex(index, pickupDate, amountValue, selected);
      }
    });
  };

  checkStockStatusForIndex = async (
    index: number,
    pickupDate: Date,
    amountValue: number,
    selected: Product,
  ) => {
    if (selected && amountValue > 0) {
      const productStockView = await this.getProductStock(selected.id);
      if (productStockView.stock_type == ProductStockTypeOnRequest) {
        return;
      }
      const toDeliver = amountValue / selected.pieces_per_unit;
      let stockAmountAtPickup = productStockView.stock_amount;
      if (productStockView.delivery_over_time) {
        productStockView.delivery_over_time.forEach(
          (delivery: DeliveryOverTime) => {
            const deliveryDate = new Date(delivery.date);
            if (deliveryDate <= pickupDate) {
              stockAmountAtPickup -= delivery.amount_in_units;
            }
          },
        );
      }
      if (productStockView.planned_production_over_time) {
        productStockView.planned_production_over_time.forEach(
          (delivery: DeliveryOverTime) => {
            const deliveryDate = new Date(delivery.date);
            if (deliveryDate <= pickupDate) {
              stockAmountAtPickup += delivery.amount;
            }
          },
        );
      }

      const valueWithNewPickup = stockAmountAtPickup - toDeliver;
      let stockStatus = StockStatusInStock;
      if (productStockView.not_in_stock_amount > valueWithNewPickup) {
        stockStatus = StockStatusOutOfStock;
      } else if (productStockView.limited_stock_amount > valueWithNewPickup) {
        stockStatus = StockStatusLimited;
      }
      const temp = this.prods;
      temp[index].stock_status = stockStatus;
      temp[index].prod = selected;
      this.prods = [];
      this.prods = temp;
    }
  };

  renderNormalInputs = () => {
    return html` <div class="row">
        <div class="label">Ordernummer LH</div>
        <div class="input-column">
          <input
            type="number"
            min="1"
            step="1"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            placeholder="ordernummer"
            id="orderID"
            name="orderID"
            @input=${() => {
              const orderNumber = this.orderID
                ? parseInt(this.orderID.value)
                : NaN;
              if (orderNumber.toString().length >= 6) {
                this.salesOrderNumber = orderNumber.toString();
                this.retrieveOrderInfoExact(orderNumber.toString());
              }
            }}
          />
        </div>
      </div>
      <div class="row">
        <div class="label">Vracht ID</div>
        <div class="input-column">
          <input
            type="text"
            placeholder="vracht id"
            id="shippingID"
            name="shippingID"
          />
        </div>
      </div>
      <div class="row">
        <div class="label">Ordernummer klant</div>
        <div class="input-column">
          <input
            type="text"
            placeholder="ordernummer klant"
            id="externalID"
            name="externalID"
          />
        </div>
      </div>
      <div class="row">
        <div class="label">Klantnaam</div>
        <div class="input-column">
          <input
            type="text"
            placeholder="klantnaam"
            id="customerName"
            name="customerName"
          />
        </div>
      </div>
      <div class="row">
        <div class="label">Plaatsnaam</div>
        <div class="input-column">
          <input
            type="text"
            placeholder="plaatsnaam"
            id="shippingCity"
            name="shippingCity"
          />
        </div>
      </div>
      <div class="row">
        <div class="label">Opmerking</div>
        <div class="input-column">
          <input
            type="text"
            placeholder="opmerking"
            id="comment"
            name="comment"
          />
        </div>
      </div>
      <div class="row">
        <div class="label">Pakbon notitie</div>
        <div class="input-column">
          <input
            type="text"
            placeholder="pakbon notitie"
            id="packageReceiptNote"
            name="packageReceiptNote"
          />
        </div>
      </div>
      <div class="row">
        <div class="label">Laaddatum</div>
        <div class="input-column">
          <input
            type="date"
            id="pickupDate"
            name="pickupDate"
            value="${formatDateInput(new Date().toISOString())}"
            @input=${() => {
              this.checkStockStatus();
            }}
          />
        </div>
      </div>
      <div class="row">
        <div class="label">PDF notitie</div>
        <div class="input-column">
          <textarea type="text" id="pdfNote" name="pdfNote"></textarea>
        </div>
      </div>`;
  };

  calculateTotalWeight = () => {
    setTimeout(() => {
      if (!this.shadowRoot) {
        return;
      }
      const productSelects =
        this.shadowRoot.querySelectorAll('.search-dropdown');
      const prodAmountInputs =
        this.shadowRoot.querySelectorAll('.product-amount');
      const result: ProdEdit[] = [];
      productSelects.forEach((e: Element, index: number) => {
        const searchDropDown = <SearchDropdown>e;
        const amountInputElement = <HTMLInputElement>prodAmountInputs[index];
        result.push(<ProdEdit>{
          amount: parseFloat(amountInputElement.value),
          prod: searchDropDown.selected ? searchDropDown.selected : undefined,
        });
      });
      let totalWeight = 0;
      result.forEach((p: ProdEdit) => {
        if (!p.prod || isNaN(p.amount)) {
          return;
        }
        totalWeight += p.amount * p.prod.weight;
      });
      totalWeight = Math.round(totalWeight);

      this.totalWeight = totalWeight;
    }, 5);
  };

  addProdInput = () => {
    const temp = this.prods;
    this.prodIndex++;
    temp.push({
      amount: 0.0,
      index: this.prodIndex,
      stock_status: StockStatusInStock,
    });
    this.prods = [];
    this.prods = temp;
  };

  removeProdInput = (index: number) => {
    if (!this.shadowRoot) {
      return;
    }
    if (this.prods.length <= 1) {
      showNotification('A pickup order needs atleast 1 product.');
      return;
    }
    const productSelects = this.shadowRoot.querySelectorAll('.search-dropdown');
    const prodAmountInputs =
      this.shadowRoot.querySelectorAll('.product-amount');
    const newProds: ProdEdit[] = [];
    prodAmountInputs.forEach((e: Element, otherIndex: number) => {
      if (otherIndex !== index) {
        const inputElement = <HTMLInputElement>e;
        const searchDropDown = <SearchDropdown>productSelects[otherIndex];

        newProds.push({
          amount: parseFloat(inputElement.value),
          index: this.prods[otherIndex].index,
          prod: searchDropDown.selected,
          stock_status: StockStatusInStock,
        });
      }
    });
    this.prods = [];
    this.prods = newProds;
  };

  createPickupOrder = async () => {
    if (this.disableButtons) return;
    this.disableButtons = true;
    const pickupOrder: PickupOrderCreateReqeust =
      this.newPickupOrderCreateRequest();
    await this.executePickupOrderCallWithValidation(pickupOrder);
    this.disableButtons = false;
  };

  newPickupOrderCreateRequest = (): PickupOrderCreateReqeust => {
    const productSelects = this.getProducts();

    let status = PickupOrderStatusInitState;
    const initEarlyChecked = this.initEarlyCheckbox
      ? this.initEarlyCheckbox.checked
      : false;
    if (initEarlyChecked) {
      status = PickupOrderStatusReadyToBeProcessed;
    }
    const onCallChecked = this.onCallCheckbox
      ? this.onCallCheckbox.checked
      : false;
    if (onCallChecked) {
      status = PickupOrderStatusOnCall;
    }

    return <PickupOrderCreateReqeust>{
      products: productSelects,
      order_id: this.orderID ? parseInt(this.orderID.value) : NaN,
      shipping_id: this.shippingID ? this.shippingID.value : '',
      external_id: this.externalID ? this.externalID.value : '',
      shipping_city: this.shippingCity ? this.shippingCity.value : '',
      customer_name: this.customerName ? this.customerName.value : '',
      package_receipt_note: this.packageReceiptNote
        ? this.packageReceiptNote.value
        : '',
      pickup_order_pdf_comment: this.pdfNote ? this.pdfNote.value : '',
      customer_code: this.customer_code,
      status: status,
      pickup_date: this.pickupDate
        ? new Date(this.pickupDate.value).toISOString()
        : '',
      pickup_order_pdf: this.pdfFileB64,
    };
  };

  getCustomerCodeByName = async (
    name: string,
  ): Promise<CustomerCodeByNameResponse> => {
    const resp = await authenticatedAPICall(
      `/accounts/customers/${name}`,
      'GET',
      new Headers(),
    );
    const response: CustomerCodeByNameResponse = {
      customer_code: '',
      error_message: '',
    };
    if (isSuccessfulAPIResponse(resp)) {
      response.customer_code = resp.body.customer_code;
      return response;
    }
    if (resp.error_message) {
      response.error_message = resp.error_message;
    }
    return response;
  };

  executePickupOrderCallWithValidation = async (
    pickupOrder: PickupOrderCreateReqeust,
  ) => {
    const errMsg = await this.validatePickupOrder(pickupOrder);
    if (errMsg !== '') {
      showNotification(errMsg);
      return;
    }
    await this.validatePickupOrderCreate(pickupOrder);
  };

  executePickupOrderCallWithoutValidation = async () => {
    const pickupOrder: PickupOrderCreateReqeust =
      this.newPickupOrderCreateRequest();
    const errMsg = await this.validatePickupOrder(pickupOrder);
    if (errMsg !== '') {
      showNotification(errMsg);
      return;
    }
    await this.callCreate(pickupOrder);
  };

  validatePickupOrderCreate = async (pickupOrder: PickupOrderCreateReqeust) => {
    const respValidate = await authenticatedAPICall(
      '/pickuporders/validate',
      'POST',
      new Headers(),
      JSON.stringify(pickupOrder),
    );
    if (
      isSuccessfulAPIResponse(respValidate) &&
      respValidate.body.messages
    ) {
      if (respValidate.body.messages.length == 0) {
        await this.callCreate(pickupOrder);
        return;
      }

      let messageResult = '';

      for (let i = 0; i < respValidate.body.messages.length; i++) {
        messageResult += `<li>${respValidate.body.messages[i]}</li>`;
      }

      confirmPopup({
        confirm_event: 'confirm_pickup_order_create',
        title: 'Pickup Order Invoeren Bevestigen',
        description: `Wij hebben de volgende mogelijke fouten gevonden in het aanmaken van de Pickup Order:<br/><ul style="text-align:left;">${messageResult}</ul>`,
        with_checkbox: false,
        checkbox_text: '',
      });
    }
  };

  callCreate = async (pickupOrder: PickupOrderCreateReqeust) => {
    const resp = await authenticatedAPICall(
      '/pickuporders',
      'POST',
      new Headers(),
      JSON.stringify(pickupOrder),
    );
    if (isSuccessfulAPIResponse(resp) && resp.body.success) {
      if (this.comment && this.comment.value != '') {
        await this.addCommentCall(resp.body.id, this.comment.value);
      }
      window.location.href = '/';
    }
  };

  addCommentCall = async (id: string, message: string) => {
    const commentPayload = {
      message: message,
      type: 'portal',
    };
    const path = `/pickuporders/${id}/comment`;
    const result = await authenticatedAPICall(
      path,
      'POST',
      new Headers(),
      JSON.stringify(commentPayload),
    );

    if (isSuccessfulAPIResponse(result) && result.body.success) {
      if (this.comment) {
        this.comment.value = '';
      }
    }
  };

  retrieveOrderInfoExact = async (orderNumber: string) => {
    if (orderNumber === '') {
      return;
    }
    this.searchOrderHeaderExact(orderNumber.toString());
    this.searchOrderLinesExact(orderNumber.toString());
  };

  searchOrderHeaderExact = async (orderNumber: string) => {
    const path = `/exact-globe/sales-order-header/${orderNumber}`;
    const result = await authenticatedAPICall(path, 'GET', new Headers());

    if (isSuccessfulAPIResponse(result)) {
      if (this.customerName) {
        this.customerName.value = result.body.order_debtor_name;
        this.customerName.disabled = true;
      }
      if (this.externalID) {
        this.externalID.value = result.body.your_reference;
        this.externalID.disabled = true;
      }
      if (this.shippingCity) {
        if (result.body.description2 == '') {
          showNotification(
            'The sales order in Exact has no city defined, please add it in Exact.',
          );
        } else {
          this.shippingCity.value = result.body.description2;
          this.shippingCity.disabled = true;
        }
      }
      this.customer_code = result.body.order_debtor_code;
    }
  };

  searchOrderLinesExact = async (orderNumber: string) => {
    const path = `/exact-globe/sales-order-lines/${orderNumber}`;
    const result = await authenticatedAPICall(path, 'GET', new Headers());

    if (isSuccessfulAPIResponse(result)) {
      const codes = [];
      for (let i = 0; i < result.body.length; i++) {
        codes.push(result.body[i].item_code);
      }
      const res: ProductExact[] = [];
      for (let i = 0; i < result.body.length; i++) {
        res.push(result.body[i]);
      }
      this.exactProducts = res;
      const resultFilter = codes.join(',');
      this.productCodeFilter = resultFilter;
    }
  };

  validatePickupOrder = async (
    pickupOrder: PickupOrderCreateReqeust,
  ): Promise<string> => {
    if (isNaN(pickupOrder.order_id)) {
      return 'Invalid order id provided.';
    }
    if (pickupOrder.shipping_id === '') {
      return "Shipping id can't be empty.";
    }
    if (pickupOrder.external_id === '') {
      return "External id can't be empty.";
    }
    if (pickupOrder.pickup_date === '') {
      return "Pickup date can't be empty.";
    }
    if (
      new Date(pickupOrder.pickup_date) <
      new Date(
        `${new Date().getFullYear()}-${
          new Date().getMonth() + 1
        }-${new Date().getDate()}`,
      )
    ) {
      return 'Pickup date cannot be in the past';
    }
    if (pickupOrder.products.length === 0) {
      return 'Specify atleast 1 pickup order product';
    }
    if (pickupOrder.customer_code === '') {
      const response = await this.getCustomerCodeByName(
        pickupOrder.customer_name,
      );
      if (response.error_message != '') {
        return response.error_message;
      }
      pickupOrder.customer_code = response.customer_code;
    }
    if (pickupOrder.customer_code === '') {
      return 'Customer details not present';
    }

    for (let i = 0; i < pickupOrder.products.length; i++) {
      const p = pickupOrder.products[i];
      if (p.amount === 0 || isNaN(p.amount)) {
        return 'Product with amount "0" is not valid';
      }
      if (!p.product_id || p.product_id === '') {
        return 'Please select the product type';
      }
      const exceedError = this.checkOrderExceeds(
        p.code,
        p.amount,
        p.pieces_per_unit,
        p.unit,
      );
      if (exceedError != '') {
        return exceedError;
      }
    }

    // check with planning
    const res = <ProductPlanningValidationRequest>{
      validations: [],
      delivery_date: pickupOrder.pickup_date,
      original_delivery_date: pickupOrder.pickup_date,
    };
    for (let i = 0; i < pickupOrder.products.length; i++) {
      const p = pickupOrder.products[i];
      res.validations.push({
        product_id: p.product_id,
        amount: p.amount / p.pieces_per_unit,
        original_amount: 0,
      });
    }
    const resp = await authenticatedAPICall(
      '/stock/validate/products',
      'POST',
      new Headers(),
      JSON.stringify(res),
    );
    if (resp.error_message) {
      return resp.error_message;
    }

    return '';
  };

  checkOrderExceeds = (
    code: string,
    amount: number,
    pieces_per_unit: number,
    unit: string,
  ): string => {
    for (let i = 0; i < this.exactProducts.length; i++) {
      const exactProduct = this.exactProducts[i];
      if (exactProduct.item_code === code) {
        const unitsPerPiece = 1 / pieces_per_unit;
        const amountInUnits = amount * unitsPerPiece;

        const quantityLeft =
          exactProduct.quantity - exactProduct.quantity_delivered;

        // In order to do correct comparisons of exceeding, we'll need to round to same amount of
        // decimals as quantityLeft
        const margin = 0.5;

        if (amountInUnits > quantityLeft + margin) {
          const quantityLeftRounded = Math.round(quantityLeft * 100) / 100;
          const amountInUnitsRounded = Math.round(amountInUnits * 100) / 100;
          return `Max aantal voor product ${exactProduct.description} is ${
            quantityLeftRounded + margin
          } ${unit}, maar er is ${amountInUnitsRounded} ${unit} ingevoerd.`;
        }
      }
    }
    return '';
  };

  getProducts = (): PickupOrderProductCreateRequest[] => {
    if (!this.shadowRoot) {
      return [];
    }
    const productSelects = this.shadowRoot.querySelectorAll('.search-dropdown');
    const prodAmountInputs =
      this.shadowRoot.querySelectorAll('.product-amount');
    const result: PickupOrderProductCreateRequest[] = [];
    productSelects.forEach((e: Element, index: number) => {
      const searchDropDown = <SearchDropdown>e;
      const amountInputElement = <HTMLInputElement>prodAmountInputs[index];
      result.push({
        amount: parseFloat(amountInputElement.value),
        product_id: searchDropDown.selected ? searchDropDown.selected.id : '',
        code: searchDropDown.selected ? searchDropDown.selected.code : '',
        pieces_per_unit: searchDropDown.selected
          ? searchDropDown.selected.pieces_per_unit
          : 1,
        unit: searchDropDown.selected ? searchDropDown.selected.unit : '',
      });
    });
    return result;
  };

  getProductStock = async (id: string): Promise<ProductStockView> => {
    const result = await authenticatedAPICall(
      `/stock/products/${id}`,
      'GET',
      new Headers(),
    );
    if (isSuccessfulAPIResponse(result)) {
      return result.body;
    }
    return <ProductStockView>{};
  };

  private _preventDefaults(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
  }

  private _handleDragEnter(event: DragEvent): void {
    this._preventDefaults(event);
    this.dragCounter++;
    if (this.dragCounter === 1) {
      this.isDragging = true;
    }
  }

  private _handleDragLeave(event: DragEvent): void {
    this._preventDefaults(event);
    this.dragCounter--;

    if (this.dragCounter === 0) {
      this.isDragging = false;
    }
  }

  private _handleDrop(event: DragEvent): void {
    this._preventDefaults(event);
    this.dragCounter = 0;

    const files = event.dataTransfer?.files;
    if (files) {
      this._processFiles(files);
    } else {
      this.isDragging = false;
    }
  }

  private _handleFileInputChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const files = inputElement.files;

    if (files) {
      this._processFiles(files);
    }
    inputElement.value = '';
  }

  async _processFiles(files: FileList) {
    if (files.length !== 1) {
      showNotification('Please drop exactly one PDF file.');
      return;
    }

    const file = files[0];
    if (file.type !== 'application/pdf') {
      showNotification('Only PDF files are allowed.');
      return;
    }
    this.isProcessing = true;
    const fileBase64 = await this._readFileAsBase64(file);
    this.pdfFileB64 = fileBase64;

    try {
      const resp = await authenticatedAPICall(
        `/ai/pickup-order-from-pdf`,
        'POST',
        new Headers(),
        JSON.stringify({
          file_base64: fileBase64,
        }),
      );
      if (!isSuccessfulAPIResponse(resp)) {
        this.isDragging = false;
        this.isProcessing = false;
        showNotification('Error processing the PDF file.');
        return;
      }
      this.pickupDate!.value = formatDateInput(
        new Date(resp.body.pickup_date).toISOString(),
      );
      this.prods = resp.body.products.map((p: Product, index: number) => ({
        amount: p.amount,
        index: index,
        prod: {
          id: p.id,
          code: p.code,
          product_id: p.id,
          description: p.description,
          product_type: p.product_type,
          amount_packs: p.amount_packs,
          weight: p.weight,
          pieces_per_pack: p.pieces_per_pack,
          pieces_per_unit: p.pieces_per_unit,
          unit: p.unit,
        },
        stock_status: StockStatusInStock, // Default status, will be updated later
      }));
      this.checkStockStatus();
      this.calculateTotalWeight();
      if (this.shippingID!.value === '') {
        this.shippingID!.value = resp.body.shipping_id;
      }
      if (this.orderID!.value === '') {
        this.orderID!.value = resp.body.order_id.toString();
        this.retrieveOrderInfoExact(resp.body.order_id.toString());
      }
      if (this.externalID!.value === '') {
        this.externalID!.value = resp.body.external_id;
      }
      if (this.customerName!.value === '') {
        this.customerName!.value = resp.body.customer_name;
      }
      if (this.customer_code === '') {
        this.customer_code = resp.body.customer_code;
      }
      if (this.shippingCity!.value === '') {
        this.shippingCity!.value = resp.body.shipping_city;
      }
    } catch (e) {
      console.error('Error processing the PDF file:', e);
      showNotification('Error processing the PDF file.');
      this.isDragging = false;
      this.isProcessing = false;
    }
    this.isDragging = false;
    this.isProcessing = false;
  }

  private _readFileAsBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = e => {
        if (e.target && e.target.result) {
          // The result is already a data URL, which starts with "data:mime/type;base64,"
          // We can extract the Base64 part directly or just send the whole data URL.
          // For simplicity, let's extract the Base64 part.
          const base64String = e.target.result.toString().split(',')[1];
          resolve(base64String);
        } else {
          reject(new Error('Failed to read file.'));
        }
      };
      reader.onerror = () => {
        reject(new Error('Error reading file.'));
      };
      reader.readAsDataURL(file); // This reads the file as a data URL
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'langhout-beton-create-pickup-order': CreatePickupOrder;
  }
}
